module.exports = __webpack_public_path__ + "img/icon-video.1d809ffa.svg";